import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonDirective } from '../../shared/directives/button.directive';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-cookie-banner',
    templateUrl: './cookie-banner.component.html',
    styleUrls: ['./cookie-banner.component.scss'],
    standalone: true,
    imports: [NgIf, ButtonDirective],
})
export class CookieBannerComponent {
  @Output() onHide = new EventEmitter();
  public showExtra = false;
}
